import { render } from "./CreateNote.vue?vue&type=template&id=051e1e55"
import script from "./CreateNote.vue?vue&type=script&lang=js"
export * from "./CreateNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__